var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncorrectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74.711,
    height: 74.711,
    viewBox: "0 0 74.711 74.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_992",
    "data-name": "Rectangle 992",
    width: 74.711,
    height: 74.711,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Incorrect_OTP",
    "data-name": "Incorrect OTP",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3159",
    "data-name": "Group 3159",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M37.337,0A37.355,37.355,0,1,1,0,37.4,37.416,37.416,0,0,1,37.337,0M6.226,37.316A31.13,31.13,0,1,0,37.371,6.226,31.186,31.186,0,0,0,6.226,37.316",
    transform: "translate(0 0)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M22.241,26.781c-.228.214-.428.394-.619.581q-4.855,4.855-9.718,9.711a3.187,3.187,0,1,1-4.556-4.444Q12,27.942,16.7,23.286c.33-.33.724-.6,1.047-.938a2.458,2.458,0,0,0-.629-.724q-4.85-4.86-9.711-9.718a3.186,3.186,0,1,1,4.386-4.614c1.642,1.595,3.247,3.23,4.866,4.849q2.509,2.509,5.015,5.015c.173.173.357.333.527.493a1.7,1.7,0,0,0,.656-.534q4.86-4.855,9.718-9.711a3.185,3.185,0,1,1,4.614,4.383c-1.557,1.608-3.159,3.176-4.743,4.76l-5.121,5.121c-.17.173-.333.357-.49.527a1.673,1.673,0,0,0,.537.656q4.825,4.835,9.66,9.66a3.26,3.26,0,0,1,1.1,2.877,3.022,3.022,0,0,1-2.084,2.584,3.073,3.073,0,0,1-3.2-.636c-.19-.16-.36-.343-.534-.52q-4.728-4.723-9.452-9.449c-.19-.19-.391-.371-.619-.585",
    transform: "translate(15.123 15.118)",
    fill: "#ec1c24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrectIcon);
export default __webpack_public_path__ + "static/media/incorrect-icon.d25a33c017dd99ac5408459faf8f9ef7.svg";
export { ForwardRef as ReactComponent };